import { render, staticRenderFns } from "./formkreditum.vue?vue&type=template&id=20bf31f2&"
import script from "./formkreditum.vue?vue&type=script&lang=js&"
export * from "./formkreditum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports